import React, { Component } from "react";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import styles from "./routeControlPoints.module.scss";
import RouteControlPointsList from "./RouteConntrolPointList";
import { withControlPoints } from "../../../shared/containers/containerControlPoints";
import { withRouteControlPoint } from "../../../shared/containers/containerRouteControlPoints";
import RouteControlPointTools from "./RouteControlPointTools";
import Scrollbars from "react-custom-scrollbars-2";

class RouteControlPoints extends Component {
  onClickHandler(id) {
    const { onSelectControlPoint } = this.props;
    onSelectControlPoint(id);
  }

  render() {
    const { routes, selectedRouteId } = this.props;

    if (selectedRouteId === null) {
      return null;
    }

    const route = routes.filter((x) => {
      return x.id === selectedRouteId;
    })[0];

    if (route === undefined || route === null) {
      return null;
    }

    return (
      <div className={styles.routeControlPointsContainer}>
        <RouteControlPointTools />
        <Scrollbars style={{ height: "95%" }} autoHide={true} ref="scrollbar">
          <RouteControlPointsList routeControlPoints={route.controlPoints} onClickHandler={this.onClickHandler.bind(this)} />
        </Scrollbars>
      </div>
    );
  }
}

export default withRouteControlPoint(withControlPoints(withRoutes(React.memo(RouteControlPoints))));
